import { Link } from "react-router-dom";
import { Compass } from "lucide-react";
import { EmptyState } from "@/components/States";
import { Button } from "@/components/ui/button";

export default function NotFoundPage() {
  return (
    <div className="mx-auto max-w-3xl">
      <EmptyState
        icon={Compass}
        title="Page not found"
        description="Nothing lives at this address."
        action={
          <Button asChild variant="outline" size="sm">
            <Link to="/">Back to recent</Link>
          </Button>
        }
      />
    </div>
  );
}
